import { QNoopPath } from "./base/QNoopPath";

export class QBinaryPath extends QNoopPath {}
